/**
 * @generated SignedSource<<41e7cd7aab84744d6eb543e84cc48805>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TransactionStatus = "CANCELED" | "CREATED" | "CREDITED" | "EXPIRED" | "FAILED" | "FINISHED" | "IN_PROGRESS" | "REFUNDED" | "REJECTED";
export type TransactionFinalizedSummaryDataQuery$variables = {
  offerId?: string | null | undefined;
};
export type TransactionFinalizedSummaryDataQuery$data = {
  readonly transaction: {
    readonly __typename: string;
    readonly asset: {
      readonly __typename: string;
      readonly description: string | null | undefined;
      readonly id: string;
      readonly isActive: boolean | null | undefined;
      readonly isBuyActive: boolean | null | undefined;
      readonly isSellActive: boolean | null | undefined;
      readonly legalUrl: string | null | undefined;
      readonly logoUrl: string | null | undefined;
      readonly marketCap: number | null | undefined;
      readonly minimumBuyAmount: PrecisionFloat | null | undefined;
      readonly minimumSellAmount: PrecisionFloat | null | undefined;
      readonly monthlyVolatility: number | null | undefined;
      readonly name: string | null | undefined;
      readonly portfolio: {
        readonly assetBalance: PrecisionFloat | null | undefined;
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly assets: {
              readonly edges: ReadonlyArray<{
                readonly assetBalance: PrecisionFloat | null | undefined;
                readonly totalInvested: PrecisionFloat | null | undefined;
                readonly totalReturn: ValueChange | null | undefined;
              } | null | undefined> | null | undefined;
            } | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
        readonly fiatBalance: PrecisionFloat | null | undefined;
      } | null | undefined;
      readonly price: PrecisionFloat | null | undefined;
      readonly price52WeeksHigh: PrecisionFloat | null | undefined;
      readonly price52WeeksLow: PrecisionFloat | null | undefined;
      readonly priceBuy: PrecisionFloat | null | undefined;
      readonly priceChange1Month: ValueChange | null | undefined;
      readonly priceChange1Week: ValueChange | null | undefined;
      readonly priceChange1Year: ValueChange | null | undefined;
      readonly priceChange24Hours: ValueChange | null | undefined;
      readonly priceChange5Years: ValueChange | null | undefined;
      readonly priceDailyHigh: PrecisionFloat | null | undefined;
      readonly priceDailyLow: PrecisionFloat | null | undefined;
      readonly priceSell: PrecisionFloat | null | undefined;
      readonly symbol: string | null | undefined;
    } | null | undefined;
    readonly assetAmount: PrecisionFloat | null | undefined;
    readonly fiatAmount: PrecisionFloat | null | undefined;
    readonly id: string;
    readonly status: TransactionStatus | null | undefined;
    readonly taxAmount: PrecisionFloat | null | undefined;
    readonly totalAmount: PrecisionFloat | null | undefined;
  } | null | undefined;
};
export type TransactionFinalizedSummaryDataQuery = {
  response: TransactionFinalizedSummaryDataQuery$data;
  variables: TransactionFinalizedSummaryDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "offerId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assetBalance",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "tradeOfferId",
            "variableName": "offerId"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "transaction",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "asset",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "symbol",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "logoUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "price",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "marketCap",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "legalUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "priceDailyHigh",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "priceDailyLow",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "price52WeeksHigh",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "price52WeeksLow",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "monthlyVolatility",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "priceChange24Hours",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "priceChange1Week",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "priceChange1Month",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "priceChange1Year",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "priceChange5Years",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "priceSell",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "priceBuy",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "minimumBuyAmount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "minimumSellAmount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isBuyActive",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isActive",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isSellActive",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AssetPortfoliosConnection",
            "kind": "LinkedField",
            "name": "portfolio",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fiatBalance",
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AssetPortfoliosEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Portfolio",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PortfolioAssetsConnection",
                        "kind": "LinkedField",
                        "name": "assets",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PortfolioAssetsEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "totalReturn",
                                "storageKey": null
                              },
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "totalInvested",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assetAmount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fiatAmount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalAmount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taxAmount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TransactionFinalizedSummaryDataQuery",
    "selections": (v4/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TransactionFinalizedSummaryDataQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "e535641d062f9d87d2edbac7d76d09cf",
    "id": null,
    "metadata": {},
    "name": "TransactionFinalizedSummaryDataQuery",
    "operationKind": "query",
    "text": "query TransactionFinalizedSummaryDataQuery(\n  $offerId: ID\n) {\n  transaction(input: {tradeOfferId: $offerId}) {\n    __typename\n    id\n    status\n    asset {\n      id\n      name\n      symbol\n      logoUrl\n      price\n      description\n      marketCap\n      legalUrl\n      priceDailyHigh\n      priceDailyLow\n      price52WeeksHigh\n      price52WeeksLow\n      monthlyVolatility\n      priceChange24Hours\n      priceChange1Week\n      priceChange1Month\n      priceChange1Year\n      priceChange5Years\n      priceSell\n      priceBuy\n      minimumBuyAmount\n      minimumSellAmount\n      isBuyActive\n      isActive\n      isSellActive\n      portfolio {\n        fiatBalance\n        assetBalance\n        edges {\n          node {\n            assets {\n              edges {\n                totalReturn\n                assetBalance\n                totalInvested\n              }\n            }\n          }\n        }\n      }\n      __typename\n    }\n    assetAmount\n    fiatAmount\n    totalAmount\n    taxAmount\n  }\n}\n"
  }
};
})();

(node as any).hash = "4ac25cd08d90010f60f1a1aa28cb4306";

export default node;
